// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgCirclePause = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.666 7.998A6.667 6.667 0 1 1 7.999 1.33"
    />
    <rect
      width={1.6}
      height={4.8}
      x={10.4}
      y={0.8}
      fill="currentColor"
      rx={0.8}
    />
    <rect
      width={1.6}
      height={4.8}
      x={12.801}
      y={0.8}
      fill="currentColor"
      rx={0.8}
    />
  </svg>
);
export const CirclePauseIcon = forwardRef(SvgCirclePause);
